import React from "react";
import {Checkbox, DatePicker, message, Modal, Pagination, Popconfirm, Select, Switch, Tooltip} from "antd";
import {QueueGet, QueueList, QueueUpdate} from "../../../models/queue";
import {AssignTruckTeam} from "./popup/AssignTruckTeam";
import {Config} from "../../../controller/Global";
import {DispatchHeaderLink} from "../DispatchHeaderLink";
import {toList, UserContext} from "../../../controller/Utils";
import Table from "antd/es/table";
import Button from "antd/es/button";
import Input from "antd/es/input";
import {WorkOrderPDFList} from "../../../models/workorder";

const _ = require('lodash');
const moment = require('moment');
const Option = Select.Option;
const MANIFEST = Config.constant.service_type.manifest;
const WORKORDER = 'workorder';
const HOTSHEET_COPY = 'hotsheet_copy';

export const pagination = Pagination;
pagination.pageSize = 25;

class QueuePage extends React.Component {
    static contextType = UserContext;
    state = {
        data: [],
        value: [],
        service_date: moment().format('YYYY-MM-DD'),
        popup_data: null,
        popupDataList: {},
        globalSearch: true,
        pagination: pagination,
        modalAssignTD: false,
        loading: false,
        move_to_route: false,
        printVisible: false,
        printBtnLoading: false,
        printChoices: {},
        row_data: null
    };
    onDateChange = (date, dateString) => {
        this.setState({service_date: dateString});
        this.fetch({service_date: dateString})
    };
    fetch = (params = {}, globalQueue = null) => {
        this.setState({params: params, loading: true});
        let globalSearch = undefined;
        params['service_date'] = params.service_date ? params.service_date : this.state.service_date;
        params['move_to_route'] = _.has(params, 'move_to_route') ? params.move_to_route : this.state.move_to_route;
        if (globalQueue === false) {
            globalSearch = false;
        }
        else {
            globalSearch = globalQueue || this.state.globalSearch;
            if (globalSearch)
                delete params['service_date'];
        }
        if(!params['ordering']){
            params['ordering'] = "service__workorder__generator__company_name";
            if (globalSearch) {
                params['ordering'] = "-service_date";
            }
        }
        QueueList(params)
            .then(response => {
                const pagination = {...this.state.pagination};
                pagination.total = response.data.count;
                this.setState({
                    data: response.data.results,
                    pagination, loading: false
                });
            });
    };
    handleSearch = (params) => {
        this.fetch(params)
    };
    moveToRoute = (id, move_to_route) => {
        const requestData = {move_to_route};
        QueueUpdate(id, requestData)
            .then(response => {
                message.success('Changes Updated');
                this.fetch();
            })
    };
    handleNameOrder = (pagination, filters, sorter) => {
        const pager = {...this.state.pagination};
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
        });
        let symbol = sorter.order === 'descend' ? '-' : '';
        this.fetch({
            page: pagination.current,
            ordering: sorter.columnKey? `${symbol}${sorter.columnKey}`: '',
            ...filters,
        });
    };
    nxtDate = (current_date) => {
        const nxtDate = moment(current_date).add(1, 'day').format('YYYY-MM-DD');
        this.setState({service_date: nxtDate, globalSearch: false});
        this.fetch({service_date: nxtDate});
    };
    prevDate = (current_date) => {
        const prevDate = moment(current_date).subtract(1, 'day').format('YYYY-MM-DD');
        this.setState({service_date: prevDate, globalSearch: false});
        this.fetch({service_date: prevDate});
    };
    onRowShowClick = (id) => {
        this.setModelBillTo(true);
        QueueGet(id)
            .then(response => {
                this.setState({popupDataList: response.data})
            });
    };
    handleWorkOrderChange = (value) => {
        if(value)
            this.fetch({workorder_type: value});
        else
            this.fetch()
    };
    handleSearchFilter = (value) => {
        this.setState({globalSearch: value});
        this.fetch({}, value)
    };
    showPrintModal = (row_data) => {
        this.setState({
            printVisible: true,
            row_data: row_data
        });
    };
    columns = [
        {
            title: 'Action',
            key: 'action',
            render: (data) => <p className="queue-data-item action-queue">
                <button type="button" onClick={() => this.onRowShowClick(data.id)} title="View"><i
                    className="fa fa-eye"/></button>
                <button type="button" title="Print" onClick={() => this.showPrintModal(data)}><i
                    className="fa fa-print"/></button>
            </p>,
        },
        {
            title: 'Manifest/BOL Number',
            dataIndex: 'service',
            key: 'type',
            render: (service) => <span>{service.manifest_number} ({service.type.toUpperCase()})</span>,
            sorter: true
        },
        {
            title: 'WorkOrder Type',
            dataIndex: 'workorder',
            key: 'workorder_type',
            render: (workorder) => <span>{workorder.hotsheet_id ? 'HOTSHEET' : 'CALL IN'}</span>
        }, {
            title: 'Waste Code',
            dataIndex: 'service',
            key: 'waste_code',
            render: (service) => <span>{!_.isEmpty(service.waste_data) ? service.waste_data.map((d, index) =>
                d.waste_stream.code).join(' / ') : "N/A in Service"}</span>,
            sorter: true
        }, {
            title: 'Generator',
            dataIndex: 'workorder',
            key: 'generator_name',
            render: (workorder) => <span>{_.get(workorder, 'generator.company_name', 'N/A')}</span>,
            sorter: true
        }, {
            title: 'Facility',
            dataIndex: 'service',
            key: 'facility_name',
            render: (service) => <span>{_.get(service, 'facility.name', 'N/A')}</span>,
            sorter: true
        }, {
            title: 'Transporter',
            dataIndex: 'service',
            key: 'transporter_name',
            render: (service) => <span>{_.get(service, 'transporter.name', 'N/A')}</span>,
            sorter: true
        }, {
            title: 'Dispatch Date',
            dataIndex: 'service_date',
            key: 'service_date',
            sorter:true
            // render: (service) => <span>{_.get(service, 'service_date', 'N/A')}</span>
        }, {
            title: 'Trucks type',
            dataIndex: 'service',
            key: 'trucks_type',
            render: (service) =>
                <span>{!_.isEmpty(service.truck_type) ? service.truck_type.map(type => type.type_name).join(', ') : "N/A"}</span>
        }, {
            title: 'Trucks & Drivers',
            // dataIndex: 'truck',
            key: 'Trucks_Drivers',
            className: "sel-driver queue-data-item",
            render: (data) => <div className="select-data">
                <div className="col-12 m-b-10 selected-td-xs">
                    {data.truck ? <div>
                            <p>Truck ID: <span>{data.truck.truck_id} | {data.truck.type.type_name}</span></p><br/>
                            <p>Assign Team: <span
                                className="driver-span">{data.members && data.members.map(member => `${member.member.first_name} ${member.member.last_name}`).join(', ')}</span>
                            </p>
                            <Button className="delete-button-td"
                                    onClick={() => this.setModalAssignTD(true, data.id, data.service.truck_type.map(type => type.id), data.service.number_people, data.service_date, true)}><i
                                className="fa fa-pencil"/></Button>
                        </div>
                        : <button type="button"
                                  onClick={() => this.setModalAssignTD(true, data.id, data.service.truck_type.map(type => type.id), data.service.number_people, data.service_date)}
                                  className="btn asign-btn">
                            <i className="fa fa-plus"/>Assign Trucks & Drivers
                        </button>}
                </div>
            </div>
        }, {
            title: 'Move to Routes',
            key: 'Move_to_Routes',
            className: "move-btn-div queue-data-item",
            render: (data) => this.state.move_to_route ?
                <span>{data.truck &&
                <Popconfirm title="Are you sure？" okText="Yes" cancelText="No"
                            onConfirm={() => this.moveToRoute(data.id, false)}>
                    <button type="button" className="btn asign-btn"><i className="fa fa-share"/> Move back to Queue
                    </button>
                </Popconfirm>}</span>
                :
                <span>{data.truck &&
                <Popconfirm title="Are you sure？" okText="Yes" cancelText="No"
                            onConfirm={() => this.moveToRoute(data.id, true)}>
                    <button type="button" className="btn asign-btn"><i className="fa fa-share"/> Move
                    </button>
                </Popconfirm>}</span>
        },
    ];
    onSwitchChange = (move_to_route) => {
        this.setState({move_to_route});
        this.fetch({move_to_route})
    };
    PDFPrintOption = (counter = 0) => {
        const {row_data, printChoices} = this.state;
        const data = toList(printChoices);
        const key = Object.keys(printChoices)[counter];
        if (key === WORKORDER || key === HOTSHEET_COPY) {
            WorkOrderPDFList({ids: row_data.workorder.id, pdf_type: key})
                .then(() => {
                    counter += 1;
                    if (data.length === counter)
                        this.setState({printBtnLoading: false, printVisible: false, printChoices: {}});
                    else
                        this.PDFPrintOption(counter, data)
                })
        }
        else if (key && key === MANIFEST) {
            WorkOrderPDFList({ids: row_data.workorder.id, manifest: printChoices[key], pdf_type: MANIFEST})
                .then(response => {
                    counter += 1;
                    if (data.length === counter)
                        this.setState({printBtnLoading: false, printVisible: false, printChoices: {}})
                    else
                        this.PDFPrintOption(counter, data)
                })
        }
    }
    onWorkOrderRowPrintClick = () => {
        this.setState({printBtnLoading: true});
        this.PDFPrintOption()
    };
    selectedChoicesPrint = (e) => {
        let {printChoices} = this.state;
        if (!e.target.checked)
            delete printChoices[e.target.name];
        else {
            printChoices[e.target.name] = e.target.value;
            this.setState({printChoices});
        }
    };

    handlePrintCancel = () => {
        this.setState({
            printVisible: false, row_data: null
        })
    };

    componentDidMount() {
        this.fetch();
    }

    setModalAssignTD(modalAssignTD, id = 0, trucks = [], number_people, service_date, update = false) {
        this.setState({
            modalAssignTD, popup_data: {
                service_id: id, trucks: trucks,
                number_people: number_people, update: update,
                service_date: service_date,
            }
        });
    }

    setModelBillTo(setQueueVisible) {
        this.setState({setQueueVisible});
    }

    render() {
        let {
            data, service_date, popupDataList, popup_data,
            pagination, params, loading, move_to_route, printBtnLoading, row_data
        } = this.state;
        // if (workorder_type === 'call_in')
        //     data = data.filter(item => !item.workorder.hotsheet_id);
        // else if (workorder_type === 'hotsheet')
        //     data = data.filter(item => item.workorder.hotsheet_id);
        const selectBefore = (
            <Select className="search-select" placeholder="Search By" value={this.state.globalSearch}
                    onChange={this.handleSearchFilter}
                    style={{width: 130, height: 40, boxShadow: 'none', border: 'none'}}>
                <Option value={false}>Current Date</Option>
                <Option value={true}>All Dates</Option>
            </Select>
        );
        return (
            <div id="main-content">
                <div className="container-fluid">
                    <div className="block-header">
                        <div className="row clearfix">
                            <div className="col-sm-3 col-12">
                                <h3 className="main-heading">AB Dispatch</h3>
                            </div>
                            <div className="col-sm-9 col-12">
                                <DispatchHeaderLink user={this.context.user}/>
                            </div>
                        </div>
                        <div className="row clearfix edit-header queue-edit-header">
                            <div className="col-12 switch-queue-div">
                                <p>View Data: </p><
                                Switch onChange={this.onSwitchChange} defaultChecked checked={move_to_route}
                                       checkedChildren="Route" unCheckedChildren="Queue"/>
                            </div>
                            <div className="col-sm-6 col-12 addon-search">
                                <Input.Search
                                    addonBefore={selectBefore}
                                    placeholder="search here"
                                    className="input-h-40"
                                    onSearch={value => this.handleSearch({"search": value})}
                                    style={{width: '100%', height: '40px'}}
                                />
                            </div>
                            <div className="col-sm-3 col-12">
                                <div id="date_range_wrapper">
                                    <DatePicker className="picker-h-40" onChange={this.onDateChange}/>
                                </div>
                            </div>
                            <div className="col-sm-3 col-12 ">
                                <Select showSearch style={{width: "100%"}} placeholder="WorkOrder Type"
                                        optionFilterProp="children" onChange={this.handleWorkOrderChange}>
                                    <Option value="">ALL</Option>
                                    <Option value="1">Call In</Option>
                                    <Option value="0">HotSheet</Option>
                                </Select>
                            </div>
                        </div>
                        {!this.state.globalSearch &&
                        <div className="row date-row">
                            <div className="col-sm-3 col-3">
                                <button className="btn" onClick={() => this.prevDate(service_date)}><i
                                    className="fa fa-angle-left"/>
                                </button>
                            </div>
                            <div className="col-sm-6 col-6">
                                <p>{service_date}</p>
                            </div>
                            <div className="col-sm-3 col-3">
                                <button type="button" onClick={() => this.nxtDate(service_date)}
                                        className="btn pull-right"><i
                                    className="fa fa-angle-right"/></button>
                            </div>
                        </div>}

                        <div className="row queue-drag">
                            <div className="col-12">
                                <div className="card queue-list">
                                    <Table
                                        className="responsive-table table table-hover js-basic-example dataTable table-custom m-b-0 c_list"
                                        dataSource={data} pagination={pagination} rowkey={row => row.id}
                                        onChange={this.handleNameOrder} loading={loading}
                                        columns={this.columns}/>
                                </div>
                                {popup_data && <AssignTruckTeam fetch={(params) => this.fetch(params)}
                                                                visible={this.state.modalAssignTD}
                                                                data={popup_data} params={params}
                                                                setModelVisible={() => this.setModalAssignTD(false)}/>}
                            </div>
                            {!_.isEmpty(popupDataList) &&
                            <Modal title="View Details" centered visible={this.state.setQueueVisible}
                                   onOk={() => this.setModelBillTo(false)}
                                   onCancel={() => this.setModelBillTo(false)} width={'75%'}
                                   className="view-data-modal queue-view-mdl">
                                <div className="main-view-queue">
                                    <div className="row view-queue-data">
                                        <div className="col-12 p-0">
                                            <h4>General Info</h4>
                                        </div>
                                        <div className="order-number queue-data-item">
                                            <span>{popupDataList.type} number</span>
                                            <span>{popupDataList.workorder.work_order_number}</span>
                                        </div>
                                        <div className="queue-data-item">
                                            <span>Generator</span>
                                            <span>{_.get(popupDataList.workorder, 'generator.company_name', 'N/A')}</span>
                                        </div>
                                        <div className="queue-data-item">
                                            <span>Bill To</span>
                                            <span>{_.get(popupDataList.workorder, 'bill_to.company_name', 'N/A')}</span>
                                        </div>
                                        <div className="queue-data-item">
                                            <span>Date</span>
                                            <span>{_.get(popupDataList.workorder, 'date', 'N/A')}</span>
                                        </div>
                                        <div className="queue-data-item">
                                            <span>PO</span>
                                            <span>{popupDataList.service.po}</span>
                                        </div>
                                    </div>
                                    <div className="row view-queue-data">
                                        <div className="col-12 p-0">
                                            <h4>Service Info</h4>
                                        </div>
                                        <div className="order-number queue-data-item">
                                            <span>{_.get(popupDataList.service, 'type') === MANIFEST ? 'Manifest' : 'BOL'} number</span>
                                            <span>{popupDataList.service.manifest_number}</span>
                                        </div>
                                        <div className="queue-data-item">
                                            <span>Service Type</span>
                                            <span>{popupDataList.service.service_type.name}</span>
                                        </div>
                                        <div className="queue-data-item">
                                            <span>Service Date</span>
                                            <span>{popupDataList.service_date}</span>
                                        </div>
                                        <div className="queue-data-item">
                                            <span>Transporter</span>
                                            <span>{popupDataList.service.transporter.name}</span>
                                        </div>
                                        <div className="queue-data-item">
                                            <span>Facility</span>
                                            <span>{popupDataList.service.facility.name}</span>
                                        </div>
                                        <div className="drivers queue-data-item">
                                            <span>Crew members</span>
                                            <span>{popupDataList.service.number_people}</span>
                                        </div>
                                        <div className="truck-type queue-data-item">
                                            <span>Trucks type</span>
                                            <span>{popupDataList.service.truck_type.map(type => type.type_name).join(', ')}</span>
                                        </div>
                                        <div className="col-12 queue-data-item p-0">
                                            <span>Job Description</span>
                                            <span>{popupDataList.service.job_description}</span>
                                        </div>
                                        {popupDataList.service.waste_data.length > 0 &&
                                        <div className="col-12 quote-waste-header">
                                            <div className="queue-data-item code-item">
                                                <span>Code</span>
                                            </div>
                                            <div className="queue-data-item description-quote">
                                                <span>Description</span>
                                            </div>
                                            <div className="queue-data-item">
                                                <span>Quantity</span>
                                            </div>
                                            <div className="queue-data-item">
                                                <span>Unit</span>
                                            </div>
                                            <div className="queue-data-item">
                                                <span>Container</span>
                                            </div>
                                        </div>}
                                        {popupDataList.service.waste_data.map(ws => <div
                                            className="col-12 quote-waste-data">
                                            <div className="queue-data-item code-item">
                                                <span>{ws.waste_stream.code}</span>
                                            </div>
                                            <div className="queue-data-item description-quote">
                                                <Tooltip placement="bottom"
                                                         title={ws.waste_stream ? ws.waste_stream.description : ''}>
                                                        <span className="description-serv info">
                                                            {ws.waste_stream ? ws.waste_stream.description : 'N/A'}
                                                        </span>
                                                </Tooltip>
                                            </div>
                                            <div className="queue-data-item">
                                                <span>{ws.quantity ? ws.quantity : 'N/A'}</span>
                                            </div>
                                            <div className="queue-data-item">
                                                <span>{ws.waste_stream.unit}</span>
                                            </div>
                                            <div className="queue-data-item">
                                                <span>{ws.container_size}</span>
                                            </div>
                                        </div>)}
                                    </div>
                                    <div className="row view-queue-data assigned-team">
                                        <div className="col-6 show-roles">
                                            <h4>Assign Team</h4>
                                            <div className="roles-header-view"><span>Name</span><span>Role</span></div>
                                            {popupDataList.members.length > 0 ? popupDataList.members.map(member =>
                                                <div className="roles-content-view">
                                                    <span> {member.member.first_name} {member.member.last_name}</span><span>{member.role}</span>
                                                </div>
                                            ) : <span className="no-member-add">Members Not Assigned Yet.</span>}
                                        </div>
                                        <div className="col-6 show-roles">
                                            <h4>Waste Stream</h4>
                                            <div className="roles-header-view">
                                                <span>Waste Code</span><span>Quantity</span></div>
                                            {popupDataList.service.waste_data.map(ws =>
                                                <div className="roles-content-view">
                                                    <span> {ws.waste_stream.code}</span><span>{ws.quantity ? ws.quantity : 'N/A'}</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Modal>}
                        </div>
                    </div>
                </div>
                <Modal title="Select Print Option" confirmLoading={printBtnLoading} visible={this.state.printVisible}
                       onOk={this.onWorkOrderRowPrintClick} onCancel={this.handlePrintCancel} okText="Download PDF"
                       className="print-modal" width={300} destroyOnClose={true}>
                    {row_data ?
                        <div>
                            <div className="check-div">
                                {row_data.workorder.hotsheet_id ?
                                    <Checkbox name={HOTSHEET_COPY} value={row_data.workorder.id}
                                              onChange={this.selectedChoicesPrint}>Print HotSheet</Checkbox> :
                                    <Checkbox name={WORKORDER} value={row_data.workorder.id}
                                              onChange={this.selectedChoicesPrint}>Print Work Order</Checkbox>
                                }
                            </div>
                            <div className="check-div uppercase-letter">
                                <Checkbox value={row_data.service.manifest_number} name={MANIFEST}
                                          onChange={this.selectedChoicesPrint}>Print {row_data.service.type}: {row_data.service.manifest_number}</Checkbox>
                            </div>
                        </div> : ""}
                </Modal>
            </div>
        );
    }
}

export const Queue = QueuePage;



// WEBPACK FOOTER //
// ./src/pages/dispatch/queue/Queue.jsx